export const queryToStringArray = (value: string[] | string | undefined): string[] => {
  if (Array.isArray(value)) {
    return value.map(i => i);
  }
  if (value) {
    return [value];
  }
  return [];
};

export const queryToNumberArray = (value: string[] | string | undefined): number[] => {
  if (Array.isArray(value)) {
    return value.map(i => +i);
  }
  if (value) {
    return [+value];
  }
  return [];
};

export const formattedPrice = (price: number): string => {
  const roundedPrice = Math.round(price);
  const absolutePrice = Math.abs(roundedPrice);
  const groupedPrice = absolutePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const sign = roundedPrice < 0 ? "-" : "";

  return `${sign}$${groupedPrice}`;
};
